var map = {
	"app/modules/company/company.module": [
		"./src/app/modules/company/company.module.ts",
		"common",
		"company.module"
	],
	"app/modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"app/modules/page/page.module": [
		"./src/app/modules/page/page.module.ts",
		"common",
		"page.module"
	],
	"app/modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"app/modules/report/report.module": [
		"./src/app/modules/report/report.module.ts",
		"common",
		"report.module"
	],
	"app/pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"home.module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"common",
		"login.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main